import { useState } from "react";
import Slider from "react-slick";
import PROFILE_IMG from "../../assets/image.jpg";
import PROFILE_IMG3 from "../../assets/s.jpg";
import PROFILE_IMG4 from "../../assets/vfvf.jpeg";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export const HomePage = () => {
  const [lang, setLang] = useState("en");

  const translations = {
    en: {
      switch: "हिंदी में बदलें",
      personal: "Personal Details",
      nickname: "NickName",
      nickValue: "Harsh, Rishabh, Harshit",
      address: "Address",
      addressValue: "Nathdwara, Rajasthan",
      birthPlace: "Birth Place",
      birthPlaceValue: "Udaipur, Rajasthan",
      birthDate: "Birth Date",
      birthDateValue: "September 5, 2002",
      zodiac: "Zodiac Sign",
      zodiacValue: "Cancer",
      birthTime: "Birth Time",
      birthTimeValue: "6:10 AM",
      height: "Height",
      heightValue: "5’ 10”",
      education: "Educational Details",
      highestEdu: "Highest Edu.",
      eduValue: "B.Tech in Computer Science",
      occupation: "Occupation Details",
      currentJob: "Currently working as",
      jobTitle: "Software Engineer",
      family: "Family Details",
      father: "Father",
      fatherValue: "Dinesh Chandra Sharma (Budetiya)",
      mother: "Mother",
      motherValue: "Manju Jangid (Dahman)",
      grandfather: "Grandfather",
      grandfatherValue: "Sohan Lal Sharma (Budetiya)",
      grandmother: "Grandmother",
      grandmotherValue: "Mangi Devi (Palecha)",
      maternalGrandfather: "Maternal Grandfather",
      maternalGrandfatherValue: "Kalu Ram Suthar (Dahman)",
      maternalGrandmother: "Maternal Grandmother",
      maternalGrandmotherValue: "ChandraKanta (Dhammu)",
    },
    hi: {
      switch: "Switch to English",
      personal: "व्यक्तिगत विवरण",
      nickname: "उपनाम",
      nickValue: "हर्ष, ऋषभ, हर्षित",
      address: "पता",
      addressValue: "नाथद्वारा, राजस्थान",
      birthPlace: "जन्म स्थान",
      birthPlaceValue: "उदयपुर, राजस्थान",
      birthDate: "जन्म तिथि",
      birthDateValue: "5 सितम्बर 2002",
      zodiac: "राशि चिन्ह",
      zodiacValue: "कर्क",
      birthTime: "जन्म समय",
      birthTimeValue: "सुबह 6:10",
      height: "कद",
      heightValue: "5 फीट 10 इंच",
      education: "शैक्षिक विवरण",
      highestEdu: "उच्चतम शिक्षा",
      eduValue: "बी.टेक कंप्यूटर साइंस",
      occupation: "व्यवसाय विवरण",
      currentJob: "वर्तमान कार्य",
      jobTitle: "सॉफ्टवेयर इंजीनियर",
      family: "परिवार विवरण",
      father: "पिता",
      fatherValue: "दिनेश चंद्र शर्मा (बुडेठिया)",
      mother: "माता",
      motherValue: "मंजू जांगिड़ (डाहमण)",
      grandfather: "दादा",
      grandfatherValue: "सोहन लाल शर्मा (बुडेठिया)",
      grandmother: "दादी",
      grandmotherValue: "मांगी देवी (पलेचा)",
      maternalGrandfather: "नाना",
      maternalGrandfatherValue: "कालू राम सुथार (डाहमण)",
      maternalGrandmother: "नानी",
      maternalGrandmotherValue: "चंद्रकांता (धम्मू)",
    },
  };

  const t = translations[lang];

  const settings = {
    dots: true,
    fade: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
  };

  const images = [PROFILE_IMG3, PROFILE_IMG4, PROFILE_IMG];

  return (
    <div className="min-h-screen bg-white flex justify-center items-center p-0 sm:p-6">
      <div className="bg-gray-100 rounded-2xl shadow-xl p-6 sm:p-10 grid grid-cols-1 md:grid-cols-[45%_55%] gap-6 w-full max-w-7xl relative overflow-hidden">

        {/* Language Toggle */}
        <button
          className="absolute top-4 right-4 bg-blue-600 text-white px-4 py-2 rounded-md text-sm z-20"
          onClick={() => setLang(lang === "en" ? "hi" : "en")}
        >
          {t.switch}
        </button>

        {/* Slider */}
        <div className="flex justify-center items-center select-none" onContextMenu={(e) => e.preventDefault()}>
          <div className="w-full p-1">
            <Slider {...settings}>
              {images.map((img, idx) => (
                <div
                  key={idx}
                  className="rounded-xl overflow-hidden shadow-md h-[300px] md:h-[350px] lg:h-[500px]"
                >
                  <img
                    src={img}
                    alt={`Slide ${idx + 1}`}
                    className="w-full h-full object-cover"
                  />
                </div>
              ))}
            </Slider>
          </div>
        </div>

        {/* Right Content */}
        <div className="space-y-8 text-sm sm:text-base text-gray-800 relative z-10">
          {/* Personal Details */}
          <section>
            <h2 className="font-bold text-lg mb-2 flex items-center gap-2 text-black">
              <span className="w-1.5 h-5 bg-blue-500 rounded-full inline-block" />
              {t.personal}
            </h2>
            <div className="grid grid-cols-2 gap-y-2">
              <div>{t.nickname}</div><div className="text-blue-700">: {t.nickValue}</div>
              <div>{t.address}</div><div>: {t.addressValue}</div>
              <div>{t.birthPlace}</div><div>: {t.birthPlaceValue}</div>
              <div>{t.birthDate}</div><div>: {t.birthDateValue}</div>
              <div>{t.zodiac}</div><div className="text-blue-700">: {t.zodiacValue}</div>
              <div>{t.birthTime}</div><div>: {t.birthTimeValue}</div>
              <div>{t.height}</div><div>: {t.heightValue}</div>
            </div>
          </section>

          {/* Education */}
          <section>
            <h2 className="font-bold text-lg mb-2 flex items-center gap-2 text-black">
              <span className="w-1.5 h-5 bg-blue-500 rounded-full inline-block" />
              {t.education}
            </h2>
            <div className="grid grid-cols-2 gap-y-2">
              <div>{t.highestEdu}</div>
              <div>: {t.eduValue}</div>
            </div>
          </section>

          {/* Occupation */}
          <section>
            <h2 className="font-bold text-lg mb-2 flex items-center gap-2 text-black">
              <span className="w-1.5 h-5 bg-blue-500 rounded-full inline-block" />
              {t.occupation}
            </h2>
            <div className="grid grid-cols-2 gap-y-2">
              <div>{t.currentJob}</div>
              <div className="text-blue-700">: {t.jobTitle}</div>
            </div>
          </section>

          {/* Family */}
          <section>
            <h2 className="font-bold text-lg mb-2 flex items-center gap-2 text-black">
              <span className="w-1.5 h-5 bg-blue-500 rounded-full inline-block" />
              {t.family}
            </h2>
            <div className="grid grid-cols-2 gap-y-2">
              <div>{t.father}</div><div>: {t.fatherValue}</div>
              <div>{t.mother}</div><div>: {t.motherValue}</div>
              <div>{t.grandfather}</div><div>: {t.grandfatherValue}</div>
              <div>{t.grandmother}</div><div>: {t.grandmotherValue}</div>
              <div>{t.maternalGrandfather}</div><div>: {t.maternalGrandfatherValue}</div>
              <div>{t.maternalGrandmother}</div><div>: {t.maternalGrandmotherValue}</div>
            </div>
          </section>
        </div>

        {/* Decorative Orb */}
        <div className="absolute right-0 top-0 w-40 h-40 md:w-60 md:h-60 bg-gradient-to-br from-purple-400 to-blue-400 opacity-30 rounded-full blur-3xl pointer-events-none z-0 translate-x-1/4 -translate-y-1/4" />
      </div>
    </div>
  );
};
